function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.47 6.59a.75.75 0 00-1.06-1.06L12 10.94 6.59 5.53a.75.75 0 00-1.06 1.06L10.94 12l-5.41 5.41a.75.75 0 001.06 1.06L12 13.06l5.41 5.41a.75.75 0 001.06-1.06L13.06 12l5.41-5.41z",
  fill: "#36354C"
});

var SvgCloseCross = function SvgCloseCross(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
};

export default SvgCloseCross;